// extracted by mini-css-extract-plugin
module.exports = {"rainbow":"Stake_rainbow__9N8y5","card":"Stake_card__7IpVP","cardRainbow":"Stake_cardRainbow__3mukh","cardPink":"Stake_cardPink__ipqSk"};